/* ================================================================
   KYC Verification — Complete JavaScript
   ================================================================ */
(function () {
  'use strict';

  var cfg = window.KYC_CONFIG || {};

  var ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
  var ALLOWED_EXT   = ['jpg', 'jpeg', 'png', 'pdf'];
  var MAX_SIZE      = 5 * 1024 * 1024; // 5 MB

  /* ── DOM refs ─────────────────────────────────────────── */
  var form = document.getElementById('kyc-form');
  if (!form) return;

  var aadhaarInput  = document.getElementById('aadhaar-file');
  var panInput      = document.getElementById('pan-file');
  var submitBtn     = document.getElementById('kyc-submit');
  var btnText       = submitBtn.querySelector('.kyc-btn-text');
  var spinner       = submitBtn.querySelector('.kyc-spinner');
  var successMsg    = document.getElementById('kyc-success');
  var errorMsg      = document.getElementById('kyc-error-msg');
  var progressWrap  = document.getElementById('kyc-progress-wrap');
  var progressBar   = document.getElementById('kyc-progress-bar');
  var progressLabel = document.getElementById('kyc-progress-label');

  /* ── Fetch CSRF token on load ─────────────────────────── */
  function fetchCSRF() {
    if (!cfg.csrfUrl) return;
    fetch(cfg.csrfUrl, { method: 'GET', credentials: 'include' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var el = document.getElementById('kyc-csrf-token');
        if (el && d.token) el.value = d.token;
      })
      .catch(function (e) { console.warn('CSRF fetch failed', e); });
  }
  fetchCSRF();

  /* ── File validation ──────────────────────────────────── */
  function validateFile(file, fieldId) {
    var errEl = document.getElementById(fieldId + '-error');
    errEl.textContent = '';
    var card = document.getElementById(fieldId + '-card');
    if (card) card.classList.remove('has-error');

    if (!file) {
      errEl.textContent = 'Please select a file.';
      if (card) card.classList.add('has-error');
      return false;
    }

    var ext  = file.name.split('.').pop().toLowerCase();
    var mimeOk = ALLOWED_TYPES.indexOf(file.type) !== -1;
    var extOk  = ALLOWED_EXT.indexOf(ext) !== -1;

    if (!mimeOk && !extOk) {
      errEl.textContent = 'Only JPG, JPEG, PNG, or PDF files are allowed.';
      if (card) card.classList.add('has-error');
      return false;
    }

    if (file.size > MAX_SIZE) {
      errEl.textContent = 'File size must be under 5 MB.';
      if (card) card.classList.add('has-error');
      return false;
    }

    return true;
  }

  /* ── Preview ──────────────────────────────────────────── */
  function escapeHtml(str) {
    return str.replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function showPreview(file, previewId, nameId, cardId) {
    var preview = document.getElementById(previewId);
    var nameEl  = document.getElementById(nameId);
    var card    = document.getElementById(cardId);

    nameEl.textContent = file.name;
    preview.innerHTML  = '';
    if (card) {
      card.classList.add('has-file');
      card.classList.remove('has-error');
    }

    if (file.type.startsWith('image/')) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = 'Document preview';
        preview.appendChild(img);
      };
      reader.readAsDataURL(file);
    } else {
      preview.innerHTML =
        '<div class="kyc-pdf-preview">📄 ' + escapeHtml(file.name) + '</div>';
    }
  }

  /* ── Drag & Drop ──────────────────────────────────────── */
  function setupDragDrop(cardId, inputId, previewId, nameId) {
    var card  = document.getElementById(cardId);
    var input = document.getElementById(inputId);
    if (!card || !input) return;

    card.addEventListener('dragover', function (e) {
      e.preventDefault();
      card.classList.add('drag-over');
    });
    card.addEventListener('dragleave', function () {
      card.classList.remove('drag-over');
    });
    card.addEventListener('drop', function (e) {
      e.preventDefault();
      card.classList.remove('drag-over');
      var file = e.dataTransfer.files[0];
      if (file) {
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
        } catch (ex) { /* Safari fallback */ }
        showPreview(file, previewId, nameId, cardId);
      }
    });
  }

  setupDragDrop('aadhaar-card', 'aadhaar-file', 'aadhaar-preview', 'aadhaar-name');
  setupDragDrop('pan-card',     'pan-file',     'pan-preview',     'pan-name');

  /* ── File input listeners ─────────────────────────────── */
  aadhaarInput.addEventListener('change', function () {
    if (this.files[0])
      showPreview(this.files[0], 'aadhaar-preview', 'aadhaar-name', 'aadhaar-card');
  });

  panInput.addEventListener('change', function () {
    if (this.files[0])
      showPreview(this.files[0], 'pan-preview', 'pan-name', 'pan-card');
  });

  /* ── Loading state ────────────────────────────────────── */
  function setLoading(loading) {
    submitBtn.disabled         = loading;
    btnText.style.display      = loading ? 'none'        : 'inline';
    spinner.style.display      = loading ? 'inline-flex' : 'none';
    progressWrap.style.display = loading ? 'block'       : 'none';
    if (!loading) {
      progressBar.style.width   = '0%';
      progressLabel.textContent = '0%';
    }
  }

  function setProgress(pct) {
    progressBar.style.width   = pct + '%';
    progressLabel.textContent = pct + '%';
  }

  function showError(msg) {
    errorMsg.textContent     = '⚠️ ' + msg;
    errorMsg.style.display   = 'block';
    successMsg.style.display = 'none';
  }

  function showSuccess() {
    successMsg.style.display = 'block';
    errorMsg.style.display   = 'none';
  }

  /* ── XHR upload with progress ─────────────────────────── */
  function uploadWithProgress(url, formData) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable) {
          setProgress(Math.round((e.loaded / e.total) * 90));
        }
      });

      xhr.addEventListener('load', function () {
        setProgress(100);
        try {
          var data = JSON.parse(xhr.responseText);
          if (xhr.status >= 200 && xhr.status < 300 && data.success) {
            resolve(data);
          } else {
            reject(new Error(data.message || 'Upload failed.'));
          }
        } catch (e) {
          reject(new Error('Invalid server response.'));
        }
      });

      xhr.addEventListener('error', function () {
        reject(new Error('Network error. Please check your connection.'));
      });

      xhr.addEventListener('timeout', function () {
        reject(new Error('Request timed out. Please try again.'));
      });

      xhr.open('POST', url);
      xhr.withCredentials = false;
      xhr.timeout = 60000;
      xhr.send(formData);
    });
  }

  /* ── Form submit ──────────────────────────────────────── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    errorMsg.style.display   = 'none';
    successMsg.style.display = 'none';

    var aadhaarFile = aadhaarInput.files[0];
    var panFile     = panInput.files[0];
    var consent     = document.getElementById('kyc-consent').checked;

    var aadhaarOk = validateFile(aadhaarFile, 'aadhaar');
    var panOk     = validateFile(panFile, 'pan');

    var consentErr = document.getElementById('consent-error');
    if (!consent) {
      consentErr.textContent = 'You must agree to the terms to proceed.';
      return;
    } else {
      consentErr.textContent = '';
    }

    if (!aadhaarOk || !panOk) return;

    if (!cfg.backendUrl) {
      showError('Backend URL not configured. Please contact support.');
      return;
    }

    setLoading(true);

    var formData = new FormData();
    formData.append('aadhaar',        aadhaarFile);
    formData.append('pan',            panFile);
    formData.append('customer_id',    String(cfg.customerId || ''));
    formData.append('customer_email', cfg.customerEmail || '');
    formData.append('csrf_token',
      document.getElementById('kyc-csrf-token').value);

    uploadWithProgress(cfg.backendUrl, formData)
      .then(function () {
        showSuccess();
        setTimeout(function () {
          sessionStorage.removeItem('kyc_checkout_url');
          window.location.href = cfg.checkoutUrl || '/checkout';
        }, 2200);
      })
      .catch(function (err) {
        showError(err.message || 'Upload failed. Please try again.');
        setLoading(false);
      });
  });

})();
